module.exports = __webpack_public_path__ + "img/bn22.55b07c7a.png";